<template>
      <section class="container">
     
      <div class="row justify-content-center">
        
        <div class="col-md-8">
          
         <div class="card border-1 shadow p-3 rounded">
  <h5 class="fw-semibold mb-3">{{ object.title }}</h5>

  <div class="lh-lg fw-normal text-dark" v-html="object.description"></div>
</div>
          
        </div>
      </div>
    </section>
</template>

<script>


export default {
  props: ['object'],
 
  
  methods: {}
};
</script>


<style scoped>




</style>